export default __webpack_public_path__ + "static/belle-tire-logo-3715abb11b72c93d35210b1bd023d3e3.svg";